import { RemoteCloneQuestion } from 'data/usecases';
import { makeApiUrlEvaluationCriteriaQuestions } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCloneQuestion = (): RemoteCloneQuestion => {
  return new RemoteCloneQuestion(
    makeApiUrlEvaluationCriteriaQuestions(),
    makeAxiosHttpClient(),
  );
};
